import type { FunctionComponent } from "react";
import { ChevronRightIcon } from "@heroicons/react/20/solid";
import type { VehicleData } from "@App/apis/rest/ayvens/driverData/responses/fleetManagerSuccessResponse";

export type ListProps = {
  items: VehicleData[];
  onSelect: (item: VehicleData) => void;
};

export const List: FunctionComponent<ListProps> = ({ items, onSelect }: ListProps) => {
  return (
    <div className="overflow-hidden bg-white shadow sm:rounded-md">
      <ul className="divide-y divide-neutral-300">
        {items.map((item) => (
          <li
            key={item.vin}
            onClick={() => onSelect(item)}
            onKeyDown={() => onSelect(item)}
            className="px-4 py-4 sm:px-6 cursor-pointer relative flex justify-between gap-x-6 py-5"
          >
            {item.numberPlate}
            <ChevronRightIcon aria-hidden="true" className="size-5 flex-none text-neutral-400" />
          </li>
        ))}
      </ul>
    </div>
  );
};
